import { render, staticRenderFns } from "./ModelImportdictionnaire.vue?vue&type=template&id=659073b7&scoped=true"
import script from "./ModelImportdictionnaire.vue?vue&type=script&lang=js"
export * from "./ModelImportdictionnaire.vue?vue&type=script&lang=js"
import style0 from "./ModelImportdictionnaire.vue?vue&type=style&index=0&id=659073b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659073b7",
  null
  
)

export default component.exports